const AppConfig = {
  baseURL: process.env.REACT_APP_BASE_URL,
  isProduction: process.env.NODE_ENV !== "development",
}

export default AppConfig
